import { SVGProps } from 'react';
import Icon from '../../Icon';

/** Fills its wrapper (LineRoundedWrapper sets the size); `stroke` sets the colour. */
const LineRoundedBell = ({ stroke, color }: SVGProps<SVGElement>) => (
  <Icon name="notification" size="100%" color={stroke ?? color} />
);

export { LineRoundedBell };
